var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sidebar" }, [
      _c("div", { staticClass: "section filter-box mt-0" }, [
        _c(
          "div",
          { staticClass: "row ic-rounded ic-border-padding ic-bg-light-gray" },
          [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "title" }, [
                _c("h3", { staticClass: "h3" }, [_vm._v("Multimedia")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "side-menu" }, [
                _c("ul", [
                  _c("li", { staticClass: "active" }, [
                    _c("a", { attrs: { href: "#" } }, [_vm._v("Zdjęcia")]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("a", { attrs: { href: "#" } }, [_vm._v("Wideo")]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("a", { attrs: { href: "#" } }, [_vm._v("Animacje")]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("a", { attrs: { href: "#" } }, [_vm._v("Logotypy")]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("small", [
                  _vm._v(
                    "korzystając z materiałów, prosimy o podpisanie\n            ich źródła jako PKP Intercity"
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section newsletter-form d-none d-lg-block" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "title" }, [
              _c("p", [_vm._v("Newsletter")]),
              _vm._v(" "),
              _c("h3", [_vm._v("Bądz na bieżąco")]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          Jeżeli chcesz otrzymywać informacje o planowanych zmianach w rozkładach jazdy, nowych promocjach zapisz się do naszego newslettera.\n        "
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "form",
              {
                staticClass: "g-3 needs-validation ic-form",
                attrs: { novalidate: "" },
              },
              [
                _c(
                  "div",
                  { staticClass: "input-group mb-3 icon icon__envelope" },
                  [
                    _c("input", {
                      staticClass: "form-control",
                      attrs: {
                        type: "email",
                        id: "",
                        placeholder: "Adres e-mail",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "m-1 mt-3" }, [
                  _c("div", { staticClass: "form-check mt-3" }, [
                    _c("input", {
                      staticClass: "form-check-input",
                      attrs: {
                        type: "checkbox",
                        value: "",
                        id: "invalidCheck",
                        required: "",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label font-size-xs",
                        attrs: { for: "invalidCheck" },
                      },
                      [
                        _vm._v(
                          "\n                  Wyrażam zgodę na przetwarzanie moich danych osobowych, zgodnie z Rozp. Parlamentu Europejskiego i Rady (UE) 2016/679.\n                  kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE.\n                "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-info mt-3",
                      attrs: { type: "submit" },
                    },
                    [_vm._v("Zapisz się")]
                  ),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }